<template>
  <modal-template v-if="readyToShow">
    <template #header>
      <div class="popup-header-title">
        <span style="padding-right:1%;">users assigned to</span>
      </div>
      <div class="popup-header">
        <span style="padding-right:1%;"><sup>[{{ account.id }}]</sup></span>
        <span>{{ account.contact.name }}</span>
      </div>
      <div style="color:white;">{{ spacer }}</div>
    </template>
    <template #body>
      <div class="table-container">
        <table>
          <thead>
          <tr>
            <th colspan="2">
              <div style="display:flex;justify-content:space-between;">
                <div style="float:left;padding-top:3%">
                  <span>assigned users</span>
                </div>
                <div style="float:right;text-align:right;">
                </div>
              </div>
            </th>
            <th style="text-align:right;">
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="user in users" :key="user">
            <td>
              <span>{{ user }}</span>
            </td>
            <td style="width:25%;">
            </td>
            <td style="width:10%;">
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template #footer>
      <button type="button" v-on:click="$emit('close', true)">close</button>
    </template>
  </modal-template>
</template>

<script>
import ModalTemplate from '@/components/ModalTemplate'

export default {
  name: 'UserList',
  props: ['dairy', 'account'],
  emits: ['close','apierror', 'apierrortext'],
  components: {
    ModalTemplate,
  },
  data: function () {
    return {
      spacer: ' '.padEnd(60, 'X'),
      readyToShow: false,
      users: [],
    }
  },
  methods: {
    setApiError: function (isError) {
      this.$emit('apierror', isError)
    },
    setApiErrorText: function (text) {
      this.$emit('apierrortext', text)
    },
  },
  mounted() {
    this.axios
        .get('assignment/listUsers', {
          params: {
            dairyId: this.dairy.id,
            customerId: this.account.id,
          }
        })
        .then(response => {
          this.users = response.data
          this.readyToShow = true
        })
        .catch(error => {
          this.setApiError(true)
          this.setApiErrorText(error.response.statusText)
        })
  },
}
</script>